import '@mos-web/config/i18n';
import RibbonCorner from 'components/common/ribbon';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider as Theme, ThemeProviderProps } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';
import { client } from '@mos-web/graphql/apolloProvider';
import { config } from '@tools/ui/consts';
import { semanticTheme } from '@tools/ui/dime';
import { theme } from '@tools/ui-utils/theme.util';
import App from './App';
import reportWebVitals from './reportWebVitals';

const ThemeProvider = Theme as unknown as React.FC<
  React.PropsWithChildren<ThemeProviderProps<object>>
>;

if (config.appEnv === 'production') {
  datadogRum.init({
    applicationId: config.dataDog.applicationId as string,
    clientToken: config.dataDog.clientToken as string,
    site: config.dataDog.site,
    service: config.dataDog.service,
    sampleRate: 100,
    premiumSampleRate: 100,
    trackUserInteractions: true,
    trackFrustrations: true,
    env: config.appEnv,
    defaultPrivacyLevel: config.dataDog.defaultPrivacyLevel as DefaultPrivacyLevel,
    allowedTracingOrigins: [config.server.baseUrl as string, /https:\/\/.*\.melioservices\.com/],
  });

  datadogRum.startSessionReplayRecording();
}

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <ThemeProvider
        theme={{
          ...theme,
          ...semanticTheme,
        }}
      >
        {config.appEnv !== 'production' && <RibbonCorner message={config.appEnv || ''} />}
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </ApolloProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
